import { render, staticRenderFns } from "./TeacherCourseLayout.vue?vue&type=template&id=51876d49&scoped=true&"
import script from "./TeacherCourseLayout.vue?vue&type=script&lang=js&"
export * from "./TeacherCourseLayout.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCourseLayout.vue?vue&type=style&index=0&id=51876d49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51876d49",
  null
  
)

export default component.exports